module.exports = __webpack_public_path__ + "img/a3-s76.953be0ef.jpg";